import React from 'react';
import PropTypes from 'prop-types';
import SimpleHeader from '../../../headers/simpleHeader';
import { trimFunction } from '../../../../common/trimData';
import Form from '../containers/Form';
import * as shapes from '../shapes';
import { t } from '../../../../../modules/infra/i18n';

const Edit = ({ item, onSubmit, onDelete, baseUrl }) => (
  <div>
    <SimpleHeader heading={t('customers:marketing_leads.edit_channel_heading')} />
    <Form
      initialValues={item}
      onSubmit={trimFunction(onSubmit)}
      onDelete={onDelete}
      baseUrl={baseUrl}
      edit
    />
  </div>
);
Edit.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  item: shapes.item.isRequired,
  baseUrl: PropTypes.string.isRequired,
};

export default Edit;
